<template lang="pug">
.video-extern
    iframe(
        v-if="url"
        :src="url"
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
    )
</template>
<script>
//import Components
export default {
    name: 'Extern',
    props: {
        video: {
            type: Object,
            required: true
        },
        provider: {
            type: Object
        }   
    },
    computed: {
        url() {
            let url;
            
            switch (this.provider.value) {
                case 'youtube':
                    url = 'https://www.youtube-nocookie.com/embed/' + this.video.title;
                    break;
                case 'vimeo':
                    url = 'https://player.vimeo.com/video/' + this.video.title;
                    break;
                case 'vimeo_stream':
                    url = 'https://vimeo.com/event/' + this.video.title + '/embed/';
                    break;
                case 'dailymotion':
                    url = 'https://www.dailymotion.com/embed/video/' + this.video.title;
                    break;
                default:
                    url = this.video.title;
            }
            return url;
        }
    }
};
</script>
<style lang="sass" scoped>

.video-extern
    @apply relative
    padding: 56.25% 0 0 0
    iframe
        @apply absolute top-0 left-0 w-full h-full
</style>
